import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { noop } from 'lodash';
import { withClickTracking } from 'components/core/library/tracking-utils';

const enhance = withClickTracking;

function isInternalLink(to, target) {
	if (!to || target === '_blank') return false;
	if (to.startsWith('http://') || to.startsWith('https://') || to.startsWith('//')) return false;
	if (to.startsWith('mailto:') || to.startsWith('tel:')) return false;
	return true;
}

export function CoreLink({
	children, href, to, handleClick, onClick, className, target, rel, getRef, as
}) {
	const hasRealClickHandler = onClick && onClick !== noop;
	const shouldRenderAsButton = as === 'button' || (hasRealClickHandler && !href && !to);

	if (shouldRenderAsButton) {
		return (
			<button
				type="button"
				onClick={handleClick}
				ref={getRef}
				className={classnames(className, 'ph-link inner-accordion-safe')}
			>
				{children}
			</button>
		);
	}

	if (isInternalLink(to, target)) {
		return (
			<Link
				to={to}
				rel={rel}
				ref={getRef}
				onClick={handleClick}
				className={classnames(className, 'ph-link inner-accordion-safe')}
				target={target}
			>
				{children}
			</Link>
		);
	}

	return (
		<a
			onClick={handleClick}
			href={href || to}
			rel={rel}
			ref={getRef}
			className={classnames(className, 'ph-link inner-accordion-safe')}
			target={target}
		>
			{children}
		</a>
	);
}

CoreLink.propTypes = {
	href: PropTypes.string,
	to: PropTypes.string,
	rel: PropTypes.string,
	getRef: PropTypes.func,
	children: PropTypes.node,
	handleClick: PropTypes.func,
	className: PropTypes.string,
	target: PropTypes.string,
	as: PropTypes.oneOf(['button']),
};

export default enhance(CoreLink);
